//import Swiper from 'swiper'
import Swiper, { Navigation, Pagination } from 'swiper';


class MySwiper2 {
	constructor() {
		this._init()
	}
	_init() {
        
        this.el = document.querySelector('[gallery-swiper]')

		if(!this.el) {
			return
		}

		Swiper.use([Navigation]);

		var swiper = new Swiper('.home_gal__swiper-container', {
			direction: 'horizontal',
			slidesPerView: 2,
			spaceBetween: 7,
			centeredSlides: true,

			/* grabCursor: true,
			paginationClickable: true, */
			
			breakpoints: {
				1024: {
					slidesPerView: 3,
					spaceBetween: 15,
				  	centeredSlides: false,
				}
			},
			navigation: {
				nextEl: ".swiper-button-next.home_gal__btn_next.swiper-button-white",
				prevEl: ".swiper-button-prev.home_gal__btn_prev.swiper-button-white"
			}
		});
		if(document.documentElement.clientWidth <= 1024){
			swiper.slideNext(50, false);
		}
	}
}
export default MySwiper2